<form class="form form_crm" [formGroup]="formGroup" novalidate>
  <div class="row no-gutters gutters-4 align-items-start" formArrayName="complexes">
    <div class="col-12 caption mb-3 mt-2">Использовать общие настройки импорта</div>
    @if (!complexes.controls.length) {
      <div class="col-12 mb-3 mt-2 text-sm">В данный момент комплексов нет</div>
    }
    @for (complex of complexes.controls; track complex; let id = $index) {
      <div class="col-6 mb-3" [formGroupName]="id">
        <app-material-input-checkbox formControlName="is_checked" [require]="true">
          {{complex.value.caption}}
          <a class="button button_icon icon icon_Previews" title="ЖК в редакторе"
            [routerLink]="['/housing2/complex', complex.value.realty_id]"
          ></a><!-- (click)="linkImport($event, complex.value.realty_id)" -->
        </app-material-input-checkbox>
        @if (complex.value.housings.length) {
          <div class="row">
            @for (housing of complex.value.housings; track housing) {
              <div class="col-md-2">
                <a [routerLink]="['/housing2/house', housing['realty_id']]">{{housing['caption']}}</a>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
  <div formArrayName="settings" class="end_block_padding">
    @for (setting of settings.controls; track setting; let id = $index) {
      <div class="row no-gutters gutters-4 align-items-start"
        [formGroupName]="id">
        <div class="col-12 caption mb-3 mt-3">{{setting.value.caption}}</div>
        <div class="col-6 mb-2">
          <app-material-input-radio-button formControlName="settings_type_prices"
            [data]="types" [labelClass]="''">Обновлять цены
          </app-material-input-radio-button>
        </div><div class="col-6 mb-2">
        <app-material-input-radio-button formControlName="settings_type_statuses"
          [data]="types" [labelClass]="''">Обновлять статусы квартир
        </app-material-input-radio-button>
      </div>
      <div class="col-6 mb-2">
        <app-material-input-radio-button formControlName="settings_type_squares"
          [data]="types" [labelClass]="''">Обновлять площади
        </app-material-input-radio-button>
      </div>
      <div class="col-6 mb-2">
        <app-material-input-radio-button formControlName="settings_type_plans"
          [data]="types" [labelClass]="''">Обновлять планировки
        </app-material-input-radio-button>
      </div>
      <div class="col-6 mb-2">
        <app-material-input-radio-button formControlName="settings_type_structure"
          [data]="types" [labelClass]="''">Обновлять структурные данные
        </app-material-input-radio-button>
      </div>
      <div class="col-6 mb-2">
        <app-material-input-radio-button formControlName="settings_type_captions"
          [data]="types" [labelClass]="''">Обновлять названия
        </app-material-input-radio-button>
      </div>
    </div>
  }
</div>
<div class="row no-gutters gutters-4 align-items-start mt-4 mb-4">
  <div class="col-6">
    <button (click)="saveForm()" type="button" [disabled]="loading"
      class="button fixed_buttons_block_main" [ngClass]="{'button_disabled': loading}">
      Сохранить
    </button>
  </div>
</div>
</form>
